// pl_pms_checkin_stay.ts
// Tłumaczenia dla PMS.Checkin.tsx i PMS.Stay.tsx (oba ekrany Front Desk)

export const plPmsCheckinStay = {

  // ── Zameldowanie (Checkin) ────────────────────────────────────────────────
  checkin: {
    title:               "Recepcja",
    arrivalsToday:       "Przyjazdy dziś",
    preCheckIn:          "Pre-zameldowanie",
    earlyCheckIn:        "Wczesne zameldowanie",
    depositRule:         "Zasada kaucji",
    depositRuleRequired: "Zasada kaucji jest wymagana.",
    documentType:        "Rodzaj dokumentu",
    passport:            "Paszport",
    idCard:              "Dowód osobisty",
    preauth:             "Preautoryzacja",
    searchPlaceholder:   "Imię, Nr rezerwacji, Pokój, Telefon, Email",
    readyRoom:           "Gotowy pokój",
    noReadyRoom:         "Brak gotowego pokoju",
    noRoom:              "Brak pokoju",
    missing:             "Brakujące",
    garage:              "Garaż",
    messages: {
      completed:          "Zameldowanie zakończone. Kodowanie klucza gotowe.",
      completedSimple:    "Zameldowanie zakończone.",
      failed:             "Zameldowanie nieudane.",
      documentRegistered: "Dokument gościa zarejestrowany i zweryfikowany.",
      documentFailed:     "Rejestracja dokumentu nieudana.",
    },
  },

  // ── Zarządzanie pobytem (Stay) ────────────────────────────────────────────
  stay: {
    title:       "Zarządzanie pobytem",
    description: "Zameldowanie, pobyty, przeniesienia pokoi, późne wymeldowanie i wymeldowanie w jednym widoku.",
    inHouseStays:"Pobyty zameldowane",
    frontOffice: "Front Office",
    frontOfficeActions:"Akcje Front Office",
    checkoutSettlement:"Rozliczenie wymeldowania",
    selectStay:  "Wybierz pobyt raz, następnie kontynuuj: późne wymeldowanie, przeniesienie lub wymeldowanie.",
    keepVisible: "Zachowaj widoczność przyjazdów i aktywności bez przełączania stron.",
    lateCheckout: {
      title:         "Późne wymeldowanie",
      description:   "Przedłuż aktywne pobyty i zaksięguj opłatę na folio.",
      applied:       "Późne wymeldowanie zastosowane",
      workflowActive:"Workflow późnego wymeldowania aktywny. Aktywny pobyt jest już wstępnie wybrany.",
    },
    roomMove: {
      title:         "Przeniesienie pokoju",
      description:   "Przenieś gościa do innego gotowego pokoju i wydaj nowy klucz.",
      completed:     "Przeniesienie pokoju zakończone i nowy klucz wydany.",
      failed:        "Przeniesienie pokoju nieudane.",
      selectRoom:    "Wybierz gotowy pokój przed przeniesieniem gościa.",
    },
    checkout: {
      title:         "Wymeldowanie",
      settle:        "Rozlicz folio, wydrukuj lub wyślij e-mailem fakturę, następnie zakończ wymeldowanie.",
      failed:        "Wymeldowanie nieudane.",
      settled:       "Wymeldowanie rozliczone i faktura wygenerowana.",
      workflowActive:"Workflow wymeldowania aktywny. Sprawdź folio i zamknij pobyt.",
    },
  },

} as const;

export default plPmsCheckinStay;
